import { makeStyle } from '../../../../../utils';
import view from '../../../../../Enums';
import {
    blackHigh,
    blackMedium,
    blackOutline,
    bold,
    centerAbs,
    overline,
    subTitle2, success
} from '../../../../../resources/styles';

const styles = {};

styles['title_flex_element'] = makeStyle({},{padding:'24px'},view.DESKTOP,{})

styles['title_flex_element_child'] = makeStyle({},{display:'flex'},view.DESKTOP,{width:'40px'})

styles['title_slider_step'] = makeStyle({...overline,...blackMedium,...bold,letterSpacing: '0.4px',textTransform: 'uppercase',width:'max-content'})

styles['title_slider_content'] = makeStyle({...blackHigh,...subTitle2,width:'max-content'})

styles['title_child_text_container'] = makeStyle({},{height:'40px',marginLeft:'12px'},view.DESKTOP,{minWidth:'40px',display:'flex',justifyContent:'center',width:'max-content'})

styles['line'] = makeStyle({height:'1px',backgroundColor:blackOutline.color,position:'relative',top:'43px'},{width:'12px',margin:'0 6px'},view.DESKTOP,{flex:1,top:'20px'})

styles['line_container'] = makeStyle({position:'relative',width:'24px'},{},view.DESKTOP,{flex:1})

styles['icon'] = makeStyle({
    width:'40px',height:'40px',padding:'2px',
    border: `1px solid ${blackOutline.color}`,
    boxSizing: 'border-box', borderRadius: '4px',
    ...blackHigh
})

styles['circle_icon'] = makeStyle({
    position:'absolute',top:'0',right:'0',transform: 'translateY(-40%) translateX(40%)',
    width:'12px',height:'12px',
    ...success
})

export default styles